"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { TabsList, TabsTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";

// The dark: duplicates are required: shared TabsTrigger sets dark:data-active:* rules that outrank plain ones.
const TRIGGER_CLASSES = [
  "h-9! rounded-lg font-semibold",
  "bg-secondary p-2 text-muted-foreground hover:bg-muted dark:text-muted-foreground",
  "data-active:bg-background data-active:text-foreground data-active:border-border",
  "dark:data-active:bg-background dark:data-active:text-foreground dark:data-active:border-border",
].join(" ");

const ProfileFormTabsHeader: FC = () => {
  const { t, isRegistrationDisabled } = useGamePageData();

  if (isRegistrationDisabled) {
    return null;
  }

  return (
    <div className="sticky top-0 z-10 bg-popover pb-2">
      <TabsList className="grid w-full grid-cols-2 gap-2 h-11! rounded-xl bg-secondary p-1">
        <TabsTrigger value="login" className={TRIGGER_CLASSES}>
          {t("game.auth.logintab", "Login")}
        </TabsTrigger>
        <TabsTrigger value="register" className={TRIGGER_CLASSES}>
          {t("game.auth.registertab", "Register")}
        </TabsTrigger>
      </TabsList>
    </div>
  );
};

export default ProfileFormTabsHeader;
